import React, { Component } from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import Select from "react-select";
import { remove, sortBy, isEmpty, filter, findIndex } from "lodash";

import "./home_nav.css";

class HomeNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsArr: [{ id: "r-" + props.roleId, name: props.roleName }],
      optionVal: props.selected_client,
      ifShowSelection: false,
      SystemAdminMode: false,
      clientAdminMode: false,
      businessUserMode: false,
      businessAdminMode: false,
      disabledAllClientsOption: true,
      sltWidth: "50px",
    };
  }

  initializeClientList(disabledAllClientsOption, clients) {
    /*
    let clientsList = disabledAllClientsOption === true || this.props.roleId > 50 ? [
        {id: 'r-' + this.props.roleId, name: this.props.roleName}
      ] :
      [
        {id: 'r-' + this.props.roleId, name: this.props.roleName},
        {name:'All Clients', id:0}
      ]*/
    //disabled all clients
    disabledAllClientsOption = true;
    let clientsList = [
      { id: "r-" + this.props.roleId, name: this.props.roleName },
    ];
    if (clients) {
      const sortedClients = sortBy(clients, function (c) {
        return c.name.toLowerCase();
      });

      if (clients.length === 1 && clients[0].id <= 1) {
        clientsList = remove(clientsList, function (c) {
          return c.id !== 0;
        });
      }
      sortedClients.forEach(function (item) {
        if (item.id > 1) {
          /*
          if (isClientUser){
            if (!isEmpty(item.businessUnits)){
              const sortedSubClients = sortBy(item.businessUnits, function(c){
                return c.name.toLowerCase()
              })
              sortedSubClients.forEach(function(sc){
                clientsList.push({id: sc.id, name: sc.name})
              })
            }
          }else{*/
          clientsList.push({ id: item.id, name: item.name });
          if (!isEmpty(item.businessUnits)) {
            const sortedSubClients = sortBy(item.businessUnits, function (c) {
              return c.name.toLowerCase();
            });
            sortedSubClients.forEach(function (sc) {
              clientsList.push({ id: sc.id, name: "      " + sc.name });
            });
          }
          //}
        }
      });
    }

    this.setState({
      optionsArr: clientsList,
      clientAdminMode: this.props.roleId > 1 && this.props.roleId < 10,
      businessUserMode: this.props.roleId > 50,
      businessAdminMode: this.props.roleId === 51,
    });
    if (
      (disabledAllClientsOption === true &&
        parseInt(this.props.selected_client, 10) === 0 &&
        clientsList.length > 1) ||
      (this.props.roleId > 50 && parseInt(this.props.selected_client, 10) === 0)
    ) {
      if (clientsList.length > 1) {
        this.setState({ optionVal: clientsList[1].id });
        this.props.selectClient(clientsList[1].id);
      }
    }
    if (
      /^\/clients/.test(this.props.location.path) ||
      /^\/employees/.test(this.props.location.path)
    ) {
      if (this.props.roleId) {
        const val = "r-" + this.props.roleId;

        this.setState({ optionVal: val, SystemAdminMode: true });
        this.props.selectClient(val);
      }
    } else {
      if (parseInt(this.props.selected_client, 10) === 0) {
        if (clientsList.length > 1) {
          this.setState({ optionVal: clientsList[1].id });
          this.props.selectClient(clientsList[1].id);
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    //const path = nextProps.location.path
    if (
      typeof nextProps.selected_client === "number" &&
      nextProps.selected_client !== this.props.selected_client
    ) {
      this.props.getClientInfo(nextProps.selected_client);
      this.setState({
        optionVal: nextProps.selected_client,
      });
    }
    if (this.props.clients !== nextProps.clients) {
      this.initializeClientList(
        this.state.disabledAllClientsOption,
        nextProps.clients,
      );
    }

    // when router is `/segments/active or /segments/archive` show 'All Clients'
    /*
    if (path === '/segments/list/archive' || path === '/segments/list/active') {
      this.setState({
        optionsArr: ['System Administrator', 'All Clients', 'Acquire Web']
			})
    }*/
    if (nextProps.roleId !== this.props.roleId) {
      const val = "r-" + nextProps.roleId;
      if (
        /^\/clients/.test(nextProps.location.path) ||
        /^\/employees/.test(nextProps.location.path)
      ) {
        this.setState({ optionVal: val });
        this.props.selectClient(val);
      }
    }
    if (nextProps.location.path !== this.props.location.path) {
      if (/^\/segments/.test(nextProps.location.path)) {
        if (!/^\/segments/.test(this.props.location.path)) {
          this.setState({ disabledAllClientsOption: true });

          this.initializeClientList(false, this.props.clients);
        }
      } else if (/^\/segment\//.test(nextProps.location.path)) {
        this.setState({ disabledAllClientsOption: true });
        this.initializeClientList(true, this.props.clients);
        if (
          parseInt(this.props.selected_client, 10) === 0 &&
          this.state.optionsArr &&
          this.state.optionsArr.length > 1
        ) {
          this.props.selectClient(this.state.optionsArr[1].id);
        }
      } else if (/^\/insights/.test(nextProps.location.path)) {
        this.setState({ disabledAllClientsOption: true });
        this.initializeClientList(true, this.props.clients);
      }
    }
  }

  handleOptionsChange(val) {
    if (isEmpty(val)) return;
    this.props.selectClient(String(val.value));
    if (parseInt(val.value, 10) > 0) {
      this.props.getClientInfo(+val.value);
    } else {
      this.props.clearClientInfo();
    }
    const { location } = this.props;
    const { path } = location;
    this.setState({
      optionVal: val && val.value ? val.value : null,
      ifShowSelection: false,
      SystemAdminMode: isNaN(val.value),
    });
    if (isNaN(val.value)) {
      const rid = parseInt(val.value.replace("r-", ""), 10);
      if (rid > 1 && rid < 10) {
        // no system admin
        this.setState({ clientAdminMode: true });
        if (rid === 3 || rid === 5) this.props.history.push("/dashboard");
      } else if (rid === 1 || rid === 51) {
        this.setState({ clientAdminMode: false });
        this.props.history.push("/dashboard");
      } else if (rid > 51) {
        this.setState({ clientAdminMode: false });
        //this.props.history.push( rid === 53 ? '/dashboard' : '/clients')
        this.props.history.push("/dashboard");
      }
    } else {
      if (path.indexOf("/employees") >= 0 || path.indexOf("/clients") >= 0) {
        this.props.history.push("/");
      }
      if (path === "/insights") this.props.history.push(path);
      if (path.indexOf("/dashboard") >= 0) {
        this.props.history.push("/");
      }
    }
    // when select any other option clear selected segment id
    this.props.selectedSegment("clear");
  }

  componentDidMount() {
    this.setState({
      disabledAllClientsOption: true,
      businessUserMode: this.props.roleId > 50,
      businessAdminMode: this.props.roleId === 51,
    });

    // when the path is '/segments' change the state of selected_client to `All Clients`
    /*
		if (/^\/segments/.test(this.props.location.path)) {
			this.setState({optionVal: 0})
      this.props.selectClient('0')
    }else if (/^\/segment\//.test(this.props.location.path)) {
      this.setState({ disabledAllClientsOption : true })

      if ((parseInt(this.props.selected_client, 10) === 0) && (this.state.optionsArr) &&
          (this.state.optionsArr.length > 1)){
          this.props.selectClient(this.state.optionsArr[1].id)
      }
    }*/
    document.body.addEventListener(
      "click",
      () => {
        this.setState({
          ifShowSelection: false,
        });
      },
      false,
    );

    if (/^\/insights/.test(this.props.location.path)) {
      this.setState({ disabledAllClientsOption: true });
      this.initializeClientList(true, this.props.clients);
    }
  }
  showList() {
    this.setState({
      ifShowSelection: true,
    });
  }

  handleJump() {
    this.setState({ disabledAllClientsOption: true });
    this.initializeClientList(true, this.props.clients);
    this.props.history.push("/segment/create");
  }

  optionRenderer(option) {
    return <span>{option.label}</span>;
  }

  filterOption(option, filterString) {
    if (isEmpty(filterString)) return option;
    //if ((option.value === '0') || (option.value.indexOf('r-') >= 0))
    //  return option
    if (option.label.toLowerCase().indexOf(filterString.toLowerCase()) >= 0)
      return option;

    const { clients } = this.props;
    const sltClients = filter(clients, function (c) {
      return (
        c.name.toLowerCase().indexOf(filterString) >= 0 &&
        !isEmpty(c.businessUnits)
      );
    });
    let hit = false;
    sltClients.forEach(function (c) {
      if (
        findIndex(c.businessUnits, function (item) {
          return item.id.toString() === option.value;
        }) >= 0
      ) {
        hit = true;
        return;
      }
    });
    if (hit) return option;
  }

  render() {
    //const path = this.props.location.path ? this.props.location.path : ""
    const sltClient = this.state.optionsArr.find((item) => {
      if (isNaN(this.state.optionVal)) return item.id === this.state.optionVal;
      else return parseInt(item.id, 10) === parseInt(this.state.optionVal, 10);
    });

    const clientOptions = [];
    this.state.optionsArr.forEach((item, index) => {
      clientOptions.push({ value: item.id.toString(), label: item.name });
    });
    const { optimizeUserDetail, loginUserDetail } = this.props;
    if (this.props.display && this.props.display === "none") return "";
    const showClientSelector = optimizeUserDetail
      ? loginUserDetail &&
        loginUserDetail.baroUid &&
        optimizeUserDetail &&
        parseInt(optimizeUserDetail.aaUser.subscriptionTierId, 10) !== 5
      : true;
    //const {roleId, client_info} = this.props
    //const hideAudienceTab = (roleId > 3) && (client_info) && (client_info.subscription.id > 3)
    return (loginUserDetail && !loginUserDetail.baroUid) ||
      (optimizeUserDetail &&
        optimizeUserDetail.aaUser &&
        optimizeUserDetail.aaUser.subscriptionTierId != 5) ||
      (loginUserDetail &&
        loginUserDetail.baroUid &&
        !optimizeUserDetail &&
        this.props.client_info &&
        parseInt(this.props.client_info.subscriptionTierId, 10) !== 5) ||
      (loginUserDetail &&
        loginUserDetail.baroUid &&
        !optimizeUserDetail &&
        !this.props.client_info &&
        this.props.selected_client &&
        isNaN(this.props.selected_client) &&
        this.props.selected_client.indexOf("r-") >= 0) ||
      (loginUserDetail &&
        loginUserDetail.baroUid &&
        optimizeUserDetail &&
        parseInt(optimizeUserDetail.aaUser.subscriptionTierId, 10) === 5 &&
        (!this.props.disabledFeatures ||
          isEmpty(this.props.disabledFeatures))) ? (
      <MuiThemeProvider>
        <div
          className="panel panel-flat no-border-radius"
          style={{
            backgroundColor: "#444444",
            padding: "0px 10%",
            height: "60px",
            display: /(\/create-internal-account|\/create-client-account|\/create-business-unit-member-account)/g.test(
              this.props.location.path,
            )
              ? "none"
              : "block",
          }}
        >
          {showClientSelector && (
            <div
              className="mt-10"
              style={{ position: "absolute", left: "10%" }}
            >
              <span
                style={{
                  color: "#FFF",
                  position: "absolute",
                  top: "10px",
                  left: "0",
                  fontSize: "16px",
                }}
              >
                {this.state.businessUserMode === true
                  ? "Business Unit"
                  : "Client"}
              </span>
              <Select
                className={
                  this.state.businessUserMode === true ? "left-90" : "left-47"
                }
                name=""
                value={sltClient ? sltClient.id.toString() : 0}
                clearable={false}
                options={clientOptions}
                optionRenderer={this.optionRenderer.bind(this)}
                onChange={this.handleOptionsChange.bind(this)}
                filterOption={this.filterOption.bind(this)}
              />
            </div>
          )}
          <div
            className="navbar navbar-default no-border no-shadow pull-right no-padding-right"
            id="navbar-second"
            style={{ paddingLeft: "0px", backgroundColor: "#273246" }}
          >
            <ul className="nav navbar-nav no-border visible-xs-block">
              <li>
                <a
                  className="text-center collapsed"
                  data-toggle="collapse"
                  data-target="#navbar-second-toggle"
                >
                  <i className="icon-menu7" />
                </a>
              </li>
            </ul>

            <div
              className="navbar-collapse no-border collapse"
              id="navbar-second-toggle"
              style={{ marginLeft: "-35px" }}
            >
              <ul className="nav navbar-nav navbar-nav-material" />
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    ) : (
      <MuiThemeProvider>
        <div
          className="panel panel-flat no-border-radius"
          style={{
            backgroundColor: "#444444",
            padding: "0px 10%",
            height: "60px",
            display: "none",
          }}
        ></div>
      </MuiThemeProvider>
    );
  }
}

export default HomeNav;



// WEBPACK FOOTER //
// ./src/components/framework/Nav/HomeNav.js